import { sis_thangdiem } from './../models/response/so-diem/sis_thangdiem';
import { BaseCRUDApi } from "./baseCRUDApi";

class ThangDiemApi extends BaseCRUDApi<sis_thangdiem>{
    constructor(path: string) {
        super(path)
    }
}
export const thangDiemApi = new ThangDiemApi('thang-diem')